import React from "react";

import {
  FiPackage,
  FiTruck,
  FiCheckCircle,
  FiClock,
  FiDownload,
} from "react-icons/fi";
import { CiMap } from "react-icons/ci";
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import Logo from "../home/img/logo_white.png";
import Stamp from "../home/img/stamp.png";
import { CiCalendar } from "react-icons/ci";
import PageTitle from "../store/PageTitle";

const MyOrder = () => {
  const StoresUrl = [
    {
      "City Gamers Kwazi RD":
        "https://www.google.com/maps/place/City+Gamers+and+electronics+world+(town)/@-15.4190192,28.2804414,17z/data=!3m1!4b1!4m6!3m5!1s0x1940f387ffebbd7d:0xc49594828f4c759d!8m2!3d-15.4190192!4d28.2804414!16s%2Fg%2F11vkfbwjpl?entry=ttu&g_ep=EgoyMDI1MDUwNi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
    },
    {
      "City Gamers Novela Mall":
        "https://www.google.com/maps/place/Novare+Great+North+Mall/@-15.3619126,28.2780447,17z/data=!3m1!4b1!4m6!3m5!1s0x1940f53d4bda9f13:0x3956a271229ae3d6!8m2!3d-15.3619126!4d28.2780447!16s%2Fg%2F11g8nmswbq?entry=ttu&g_ep=EgoyMDI1MDUwNi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
    },
    {
      "City Gamers Arcades Mall":
        "https://www.google.com/maps/place/City+Gamers+And+electronics+world+(arcades+branch)/@-15.3926598,28.3159936,17z/data=!3m1!4b1!4m6!3m5!1s0x19408b006a665f29:0xe77d1c4bb239d894!8m2!3d-15.3926598!4d28.3159936!16s%2Fg%2F11ybh2h71j?entry=ttu&g_ep=EgoyMDI1MDUwNi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
    },
  ];
  const location = useLocation();
  const { order, orderItems } = location.state || {};
  console.log("order img", orderItems.item_img);
  console.log("my orders", order);
  console.log("my order items", orderItems);

  const getStatusIcon = (status) => {
    switch (status) {
      case "pending":
        return <FiClock className="status-icon yellow" />;
      case "In Transit":
        return <FiTruck className="status-icon blue" />;
      case "delivered":
        return <FiCheckCircle className="status-icon green" />;
      default:
        return <FiPackage className="status-icon gray" />;
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "Invalid date";

    if (typeof timestamp === "string") {
      // Convert string date to JavaScript Date object
      return new Date(timestamp).toLocaleString();
    } else if (typeof timestamp === "object" && timestamp.seconds) {
      // Firebase timestamp case
      return new Date(timestamp.seconds * 1000).toLocaleString();
    } else {
      return "Unknown format";
    }
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    const pageW = 210;
    const margin = 14;
    const contentW = pageW - margin * 2;

    const logoImg = new Image();
    logoImg.src = Logo;
    logoImg.crossOrigin = "anonymous";

    const stampImg = new Image();
    stampImg.src = Stamp;
    stampImg.crossOrigin = "anonymous";

    let loadedCount = 0;
    const totalNeeded = order.payment_status?.toLowerCase() === "paid" ? 2 : 1;

    const onImageReady = () => {
      loadedCount++;
      if (loadedCount < totalNeeded) return; // wait for both
      buildPDF(logoLoaded, stampLoaded);
    };

    let logoLoaded = false;
    let stampLoaded = false;

    logoImg.onload = () => {
      logoLoaded = true;
      onImageReady();
    };
    logoImg.onerror = () => {
      onImageReady();
    };

    if (order.payment_status?.toLowerCase() === "paid") {
      stampImg.onload = () => {
        stampLoaded = true;
        onImageReady();
      };
      stampImg.onerror = () => {
        onImageReady();
      }; // proceed without stamp
    }

    const buildPDF = (hasLogo, hasStamp) => {
      // ─── HEADER BAND ───────────────────────────────────────────
      doc.setFillColor(20, 20, 20); // near-black
      doc.rect(0, 0, pageW, 42, "F");

      if (logoImg) {
        doc.addImage(logoImg, "PNG", margin, 7, 26, 26);
      }

      if (stampImg) {
        // If your jsPDF supports opacity
        if (doc.GState) {
          doc.saveGraphicsState();
          doc.setGState(new doc.GState({ opacity: 0.25 }));
        }

        // Center of page as a watermark
        doc.addImage(stampImg, "PNG", 55, 95, 100, 100);

        if (doc.GState) {
          doc.restoreGraphicsState();
        }
      }

      // Company name — right side of header
      doc.setFont("helvetica", "bold");
      doc.setFontSize(15);
      doc.setTextColor(255, 255, 255);
      doc.text("CITY GAMERS", pageW - margin, 17, { align: "right" });

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(180, 180, 180);
      doc.text("& ELECTRONIC WORLD", pageW - margin, 24, { align: "right" });

      doc.setFontSize(7.5);
      doc.setTextColor(130, 130, 130);
      doc.text("Lusaka, Zambia", pageW - margin, 31, { align: "right" });

      // ─── RECEIPT TITLE + ORDER META ────────────────────────────
      let y = 54;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.setTextColor(30, 30, 30);
      doc.text("ONLINE RECEIPT", margin, y);

      // Order ID badge — right aligned
      doc.setFillColor(245, 245, 245);
      doc.roundedRect(pageW - margin - 68, y - 12, 68, 16, 2, 2, "F");
      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      doc.text("ORDER", pageW - margin - 34, y - 5, { align: "center" });
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.setTextColor(40, 40, 40);
      doc.text(`#${order.id}`, pageW - margin - 34, y + 1, { align: "center" });

      y += 8;

      // Thin red accent line under title
      doc.setDrawColor(200, 30, 30);
      doc.setLineWidth(1.2);
      doc.line(margin, y, margin + 30, y);
      doc.setLineWidth(0.2);

      y += 10;

      // ─── META GRID (2 columns) ──────────────────────────────────
      const metaLeft = [
        ["Date", formatDate(order.order_date)],
        ["Order Status", order.order_status],
      ];
      const metaRight = [
        ["Payment", order.payment_status],
        [
          "Delivery",
          order.deliveryMode === "pickup" ? "Store Pickup" : "Home Delivery",
        ],
      ];

      doc.setFontSize(8);
      const colMid = margin + contentW / 2 + 4;

      metaLeft.forEach(([label, value]) => {
        doc.setFont("helvetica", "normal");
        doc.setTextColor(130, 130, 130);
        doc.text(label.toUpperCase(), margin, y);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(40, 40, 40);
        doc.text(value ?? "—", margin, y + 5);
        y += 14;
      });

      // Reset y for right column
      y -= 28;
      metaRight.forEach(([label, value]) => {
        doc.setFont("helvetica", "normal");
        doc.setTextColor(130, 130, 130);
        doc.text(label.toUpperCase(), colMid, y);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(40, 40, 40);
        doc.text(value ?? "—", colMid, y + 5);
        y += 14;
      });

      y += 4;

      // ─── SECTION DIVIDER ───────────────────────────────────────
      doc.setDrawColor(220, 220, 220);
      doc.setLineWidth(0.3);
      doc.line(margin, y, pageW - margin, y);
      y += 8;

      // ─── ITEMS TABLE HEADER ─────────────────────────────────────
      doc.setFillColor(30, 30, 30);
      doc.rect(margin, y, contentW, 9, "F");

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.setTextColor(255, 255, 255);
      doc.text("ITEM", margin + 3, y + 6);
      doc.text("QTY", margin + contentW * 0.62, y + 6, { align: "center" });
      doc.text("UNIT PRICE", margin + contentW * 0.8, y + 6, {
        align: "center",
      });
      doc.text("SUBTOTAL", pageW - margin - 2, y + 6, { align: "right" });

      y += 9;

      // ─── ITEMS ROWS ─────────────────────────────────────────────
      orderItems.forEach((item, i) => {
        const rowBg = i % 2 === 0;
        if (rowBg) {
          doc.setFillColor(249, 249, 249);
          doc.rect(margin, y, contentW, 10, "F");
        }

        const subtotal = (parseFloat(item.item_price) * item.quantity).toFixed(
          2,
        );

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.setTextColor(40, 40, 40);

        // Wrap long item names
        const nameLines = doc.splitTextToSize(item.item_name, contentW * 0.56);
        doc.text(nameLines, margin + 3, y + 7);

        doc.setFont("helvetica", "normal");
        doc.setTextColor(60, 60, 60);
        doc.text(`${item.quantity}`, margin + contentW * 0.62, y + 7, {
          align: "center",
        });
        doc.text(
          `K${parseFloat(item.item_price).toFixed(2)}`,
          margin + contentW * 0.8,
          y + 7,
          { align: "center" },
        );

        doc.setFont("helvetica", "bold");
        doc.setTextColor(30, 30, 30);
        doc.text(`K${subtotal}`, pageW - margin - 2, y + 7, { align: "right" });

        const rowH = nameLines.length > 1 ? 14 : 10;
        y += rowH;
      });

      // ─── DELIVERY ADDRESS ───────────────────────────────────────
      y += 6;
      doc.setDrawColor(220, 220, 220);
      doc.setLineWidth(0.3);
      doc.line(margin, y, pageW - margin, y);
      y += 8;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.setTextColor(130, 130, 130);
      doc.text("DELIVERY ADDRESS", margin, y);
      y += 6;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9.5);
      doc.setTextColor(40, 40, 40);

      if (order.deliveryMode === "pickup") {
        doc.text(order.delivery_info?.store ?? "Store Pickup", margin, y);
        y += 7;
      } else {
        if (order.delivery_info?.zone) {
          doc.text(order.delivery_info.zone, margin, y);
          y += 6;
        }
        if (order.delivery_info?.street) {
          doc.text(order.delivery_info.street, margin, y);
          y += 6;
        }
      }

      // ─── TOTAL BOX ──────────────────────────────────────────────
      y += 6;

      // Delivery fee line (if available)
      if (order.delivery_fee) {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.setTextColor(100, 100, 100);
        doc.text("Delivery Fee:", pageW - margin - 50, y);
        doc.setTextColor(60, 60, 60);
        doc.text(
          `K${parseFloat(order.delivery_fee).toFixed(2)}`,
          pageW - margin,
          y,
          { align: "right" },
        );
        y += 7;
      }

      // Separator before total
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.3);
      doc.line(pageW - margin - 70, y, pageW - margin, y);
      y += 6;

      // Total amount
      doc.setFillColor(20, 20, 20);
      doc.roundedRect(pageW - margin - 72, y - 6, 72, 14, 2, 2, "F");

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(160, 160, 160);
      doc.text("TOTAL", pageW - margin - 44, y + 1, { align: "center" });

      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.setTextColor(255, 255, 255);
      doc.text(
        `K${parseFloat(order.total).toFixed(2)}`,
        pageW - margin - 4,
        y + 5,
        { align: "right" },
      );

      // ─── FOOTER ─────────────────────────────────────────────────
      const footerY = 278;

      doc.setDrawColor(220, 220, 220);
      doc.setLineWidth(0.3);
      doc.line(margin, footerY - 6, pageW - margin, footerY - 6);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(100, 100, 100);
      doc.text(
        "Thank you for shopping with City Gamers & Electronics World!",
        pageW / 2,
        footerY,
        {
          align: "center",
        },
      );

      doc.setFontSize(7.5);
      doc.setTextColor(160, 160, 160);
      doc.text(
        "For queries, contact us on +260 976 276 465",
        pageW / 2,
        footerY + 5,
        { align: "center" },
      );

      doc.save(`receipt-${order.id}.pdf`);
    };

    logoImg.onload = () => buildPDF(true);
    logoImg.onerror = () => buildPDF(false);
  };

  return (
    <div>
      <PageTitle title="My Order" />
      <div className="order-container">
        <div className="order-card">
          <div className="order-header">
            <div className="order-title">
              <h2>Order #{order.id}</h2>
              <span>{order.payment_reference}</span>
              <p className="order-date">
                <CiCalendar size="25" /> Placed on{" "}
                {formatDate(order.order_date)}
              </p>
            </div>
            <div className="status-container">
              <div className="status-indicator">
                {getStatusIcon(order.order_status)}
                <span className="status-text">
                  {order.order_status.replace("-", " ")}
                </span>
              </div>
              <button onClick={generatePDF} className="download-button">
                <FiDownload className="download-icon" />
                Download Receipt
              </button>
            </div>
          </div>

          <div className="order-content">
            {/* Order Items */}
            <div className="order-items">
              <h3>Items</h3>
              {orderItems.map((item) => (
                <div key={item.id} className="order-item">
                  <img
                    src={
                      typeof item.item_img === "string" && item.item_img
                        ? item.item_img
                        : "/placeholder-image.jpg"
                    }
                    alt={item.item_name || "Unnamed Item"}
                    className="item-image"
                  />
                  <div className="item-details">
                    <h4>{item.name}</h4>
                    <p>Quantity: {item.quantity}</p>
                  </div>
                  <div className="item-price">
                    <p>K{item.item_price * item.quantity}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Shipping Details */}
            <div className="shipping-details">
              <h3>
                {order?.deliveryMode === "pickup"
                  ? "Pickup Store"
                  : "Delivery Address"}
              </h3>

              {order?.deliveryMode === "pickup" ? (
                <>
                  <p>{order.delivery_info?.store}</p>
                  {StoresUrl.find(
                    (store) => store[order.delivery_info?.store],
                  ) ? (
                    <a
                      href={
                        StoresUrl.find(
                          (store) => store[order.delivery_info?.store],
                        )[order.delivery_info?.store]
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="google-maps-link"
                    >
                      <CiMap size={25} className="google-maps-icon" />
                      Open in Google Maps
                    </a>
                  ) : (
                    <p>Store location not available</p>
                  )}
                </>
              ) : (
                <>
                  <p>{order.delivery_info?.zone}</p>
                  <p>{order.delivery_info?.street}</p>
                </>
              )}
            </div>

            {/* Order Summary */}
            <div className="order-summary">
              <div className="total-amount">
                <h3>Total Amount</h3>
                <p>K{order.total.toFixed(2)}</p>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .order-container {
            max-width: 800px;
            margin: 0 auto;
            padding: 2rem;
          }

          .order-card {
            background: white;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            border: 1px solid #e5e7eb;
          }

          .order-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1.5rem;
            border-bottom: 1px solid #e5e7eb;
          }

          .order-title h2 {
            font-size: 1.25rem;
            margin: 0;
          }

          .order-date {
            color: #6b7280;
            font-size: 0.875rem;
            margin: 0.25rem 0 0;
          }

          .status-container {
            display: flex;
            align-items: center;
            gap: 1rem;
          }

          .status-indicator {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .status-icon {
            width: 1.25rem;
            height: 1.25rem;
          }

          .status-text {
            text-transform: capitalize;
          }

          .blue {
            color: #3b82f6;
          }
          .green {
            color: #10b981;
          }
          .yellow {
            color: #f59e0b;
          }
          .gray {
            color: #6b7280;
          }

          .download-button {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.5rem 1rem;
            background: white;
            border: 1px solid #e5e7eb;
            border-radius: 4px;
            cursor: pointer;
            transition: background 0.2s;
          }

          .download-button:hover {
            background: #f3f4f6;
          }

          .order-content {
            padding: 1.5rem;
          }

          .order-items {
            margin-bottom: 2rem;
          }

          .order-item {
            display: flex;
            align-items: center;
            gap: 1rem;
            padding: 1rem 0;
            border-bottom: 1px solid #e5e7eb;
          }

          .item-image {
            width: 80px;
            height: 80px;
            object-fit: cover;
            border-radius: 4px;
          }

          .item-details {
            flex: 1;
          }

          .item-details h4 {
            margin: 0 0 0.25rem;
          }

          .item-price {
            font-weight: 500;
          }

          .shipping-details {
            margin: 2rem 0;
          }

          .order-summary {
            border-top: 1px solid #e5e7eb;
            padding-top: 1.5rem;
          }

          .total-amount {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0.5rem;
          }

          .delivery-date {
            color: #6b7280;
            font-size: 0.875rem;
          }
          .google-maps-link {
            align-items: center;
            gap: 0.5rem;
            color: #3b82f6;
            text-decoration: none;
            font-weight: 500;
            margin-top: 0.5rem;
          }

          .google-maps-link:hover {
            text-decoration: underline;
          }

          .google-maps-icon {
            color: #3b82f6;
          }
        `}</style>
      </div>
    </div>
  );
};

export default MyOrder;
